import React from 'react';
import {useState,useEffect,Component} from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';
import moment from 'moment/moment';
import { Helmet } from "react-helmet";

import './Resources/dashboard.css';
import axios from '../axios.js';
import Navbar from './Supportingfiles/navbar.js';
import Sidebar from './Supportingfiles/sidebar.js';
//import Create_customers from './create_customers';
import {useRef as useref} from 'react';
import {useReactToPrint} from 'react-to-print';

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import Chart from "chart.js/auto";
import { Line, Bar } from "react-chartjs-2";


//EXCEL DOWNLOAD IMPORT
//import * as XLSX from 'xlsx';
//import { saveAs } from 'file-saver';

function Admin_createteam(){




    //Invoice Print Function
    const componentRef = useref();
    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
    });
    
 //Checking Sessions
 // Access value associated with the login status
 const logstatus=sessionStorage.getItem("logStatus00");
 const logtype=sessionStorage.getItem("logType00");
 const logid=sessionStorage.getItem("logId00");
 const token=sessionStorage.getItem("logToken00");



   //FILTER VARIABLES

   
  //Variables for pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [pageNumber, setpageNumber] = useState(1);
     

  //filter_val
  const[filterval,setfilterval]=useState(0);
  const[errorvar,seterrorvar]=useState();

  //Variables
  const[data,setData] = useState([]);//SetData Variable


  const[team_code,setteam_code]=useState();const updateteam_code = (event) => { setteam_code(event.target.value);}; const[team_code_er,setteam_code_er]=useState();
  const[team_name,setteam_name]=useState();const updateteam_name = (event) => { setteam_name(event.target.value);}; const[team_name_er,setteam_name_er]=useState();
  const[type,settype]=useState();const updatetype = (event) => { settype(event.target.value);}; const[type_er,settype_er]=useState();
  const[category,setcategory]=useState();const updatecategory = (event) => { setcategory(event.target.value);}; const[category_er,setcategory_er]=useState();
  const[status,setstatus]=useState();const updatestatus = (event) => { setstatus(event.target.value); }; const[status_er,setstatus_er]=useState();

  
 //ERROR VARIABLES 
 const[error_msg,seterror_msg]=useState();

 //image upload
 //File Upload
 const [selectedFile, setSelectedFile] = React.useState(null);
 const handleFileChange = (event) => {  const file = event.target.files[0];  setSelectedFile(file); };
 const[attachment_link_er,setattachment_link_er]=useState();

 
/***************** CREATE TEAM FUNCTION START  ******************/
function addnewteam(){

  
  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))){


    //Setting Error Variables
    setteam_code_er(" ");setteam_name_er(" ");settype_er(" ");setcategory_er(" ");setstatus_er(" ");
    seterror_msg(" ");
       
//Fetching Form Data
let noerror = 0;
let $team_code = document.getElementById("team_code").value; if($team_code==""){ setteam_code_er("Team Code is required !");noerror = noerror+1; }//team_code
let $team_name = document.getElementById("team_name").value; if($team_name==""){ setteam_code_er("Team Name is required !");noerror = noerror+1; }//team_name
let $type = document.getElementById("type").value; if($type==""){ setteam_code_er("Type is required !");noerror = noerror+1; }//type
let $category = document.getElementById("category").value; if($category==""){ setteam_code_er("Category is required !");noerror = noerror+1; }//category
let $status = document.getElementById("status").value; if($status==""){ setteam_code_er("Status is required !");noerror = noerror+1; }//status

//No primary errors
if(noerror==0){

  const addBtn = document.getElementById("submit-btn");
  addBtn.disabled = true;
  addBtn.innerText = "Processing..."; // optional


    //disabling button
    document.getElementById('submit-btn').disabled = true; 


  //Sending Data through axios
  axios.post("create-team", { 
  Log_id:logid,
  Token:token,
  Team_code:$team_code,
  Team_name:$team_name,
  Type:$type,
  Category:$category,
  Team_status:$status,
 
  },{
    headers: { "Content-Type": "multipart/form-data" },
    }
    )
  
  .then((response) => {

     
    // In case of network or server error
    addBtn.disabled = false;
    addBtn.innerText = "Create New Team";

      //enabling button
     // document.getElementById('submit-btn').disabled = false; 


  //Validation Errors
  if(response.data.validatorerror){
  setteam_code_er(response.data.validatorerror.team_code);
  setteam_name_er(response.data.validatorerror.team_name);
  settype_er(response.data.validatorerror.Type);
  setcategory_er(response.data.validatorerror.Category);
  setstatus_er(response.data.validatorerror.Team_status);
  seterror_msg("Cannot Create Team !");
  
  
  }
  //Invalid Entries
  if(response.data.error==102){ 

//  settraining_name_er(response.data.validatorerror.Training_name);

  setteam_code_er(response.data.team_code_er);
  setteam_name_er(response.data.team_name_er);
  settype_er(response.data.type_er);
  setcategory_er(response.data.category_er);
  setstatus_er(response.data.team_status_er);
  seterror_msg("Cannot Create Team !");
  
  
  }
  
  //Branch Name or Branch Code Already Exists
  if(response.data.error==103){  seterror_msg(response.data.error_msg); return; }
  
  //Success
  if(response.data.successvar==1){ 
    
    setteam_code(" ");setteam_name(" ");settype(" ");setcategory(" ");setstatus(" ");
    document.getElementById("success-card").style.display="block"; }

  //failure
  if(response.data.successvar==6){ seterror_msg("Cannot Create Team !"); }

  //Session Expired
  if(response.data.successvar==100){ seterror_msg("Session Expired !");  }


  }    );
  
  }
  

  }
  //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
 sessionStorage.removeItem("logStatus00");
 sessionStorage.removeItem("logId00");
 sessionStorage.removeItem("logToken00");
 sessionStorage.removeItem("logName00");
 
 window.location.replace("/");
 
 
 }    

}

/***************** CREATE TEAM FUNCTION END  ******************/


 
return(
    <>
     <Helmet>
            <meta name="robots" content="noindex,nofollow" />
     </Helmet>
<html lang="en">
  <head>
    {/*} Required meta tags */}
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
    <title>BUSINESS SAMADHAN | DOCUMENT MANAGEMENT SYSTEM</title>
    {/*} plugins:css */}
    <link rel="stylesheet" href="panel/assets/vendors/mdi/css/materialdesignicons.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/flag-icon-css/css/flag-icon.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/css/vendor.bundle.base.css" />
    {/*} endinject */}
    {/*} Plugin css for this page */}
    <link rel="stylesheet" href="panel/assets/vendors/jquery-bar-rating/css-stars.css" />
    <link rel="stylesheet" href="panel/assets/vendors/font-awesome/css/font-awesome.min.css" />
    {/*} End plugin css for this page */}
    {/*} inject:css */}
    {/*} endinject */}
    {/*} Layout styles */}
    <link rel="stylesheet" href="panel/assets/css/demo_1/style.css" />
    {/*} End layout styles */}
    <link rel="shortcut icon" href="panel/assets/images/favicon.png" />
  </head>
  <body>
    <div className="container-scroller">

      <Sidebar />
    <div className="container-fluid page-body-wrapper">


       <Navbar />
        {/*} partial */}
        <div className="main-panel">

        

          <div className="content-wrapper pb-0">

        {/* CREATE SUCCESS CARD START */}
       <div class="d-flex justify-content-center">
               <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="success-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title  text-success">Team Created Successfully !!!</h4>
                  
                    <blockquote class="blockquote">
                      <p class="mb-0"> Click the following button to continue.</p>
                      <a><button class="mt-3 btn btn-outline-success"  onClick={()=>{
                       // sessionStorage.removeItem("EditId");
                        document.getElementById("success-card").style.display="none";
                        
                      }}>Continue</button></a>
                    </blockquote>
                  </div>
              
                </div>
              </div>
       </div>
      {/* CREATE SUCCESS CARD END */}

            <div className="page-header flex-wrap">
            <div className="header-left">  
           
            </div>
              <div className="header-right d-flex flex-wrap mt-2 mt-sm-0">
                <div className="d-flex align-items-center">
                  <a href="#">
                    <p className="m-0 pe-3">ADMIN PANEL</p>
                  </a>
                  <a className="ps-3 me-4" href="#">
                    <p className="m-0">CREATE NEW TEAM</p>
                  </a>
                </div>

              </div>
            </div>

            {/*} chart row starts here */}
            <div className="row">

          
            </div>

          
            <div className="row">
              <div className="col-12 grid-margin">
          
            {/* CREATE LICENSE FORM START */}
            <div class="card">
              
                  <div class="card-body" style={{textAlign:"left"}}>
                    <h4 class="card-title">Create New Team</h4>
                    <div class="form-sample">
                      <p class="card-description">create team</p>
                      <code>{error_msg}</code>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label"> Team Code<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" id="team_code" placeholder="TEAM0001" value={team_code} onChange={updateteam_code} />
                              <code>{team_code_er}</code>
                            </div>
                          </div>
                        </div>
                         <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Team Name<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" id="team_name"  placeholder="Team Name" value={team_name} onChange={updateteam_name} />
                              <code>{team_name_er}</code>
                            </div>
                          </div>
                        </div>
                        </div>
                        <div class="row">
                         <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Type<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" id="type" value={type} placeholder="Type" onChange={updatetype} />
                              <code>{type_er}</code>
                            </div>
                          </div>
                        </div>
                         <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Status<code>*</code></label>
                            <div class="col-sm-9">
                              <select class="form-control" id="status" value={status} onChange={updatestatus} style={{padding:"1rem"}}>
                              <option value="active">active</option>
                              <option value="inactive">inactive</option>
                              </select>
                              <code>{status_er}</code>
                            </div>
                          </div>
                        </div>
                        </div>
                        <div class="row">
                         <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Category<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" id="category" value={category} placeholder="Category" onChange={updatecategory} />
                              <code>{category_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                            <button class="btn btn-lg btn-primary" style={{fontWeight:"bold", backgroundColor:"#c82722", borderColor:"#ffffff"}} onClick={addnewteam} id="submit-btn">Create New Team</button>
                         </div>
                        </div>
                    

                    </div>
                  </div>
                </div>
            {/* CREATE LICENSE FORM END */}

              </div>
          </div>

            


          {/*}  <button type="button" style={{backgroundColor:"#196fb0",marginTop:"2rem",marginLeft:"2rem"}} class="btn btn-secondary btn-icon-text" onClick={handlePrint}> Print <i class="mdi mdi-file-document"></i>
            </button>
            <button class="btn btn-dark" style={{marginTop:"2rem",marginLeft:"2rem"}} onClick={getexcelData}><i class="mdi mdi-file-excel text-light"></i> Download</button>
          */}
           <br/><br/><br/>
            
          </div>
          {/*} content-wrapper ends */}
          {/*} partial:partials/_footer.html */}
       {/*}   <footer className="footer">
            <div className="d-sm-flex justify-content-center justify-content-sm-between">
              <span className="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2021 <a href="https://www.bootstrapdash.com/" target="_blank">BootstrapDash</a>. All rights reserved.</span>
              <span className="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Hand-crafted & made with <i className="mdi mdi-heart text-danger"></i></span>
            </div>
          </footer> */}
          {/*} partial */}
        </div>
        {/*} main-panel ends */}
      </div>
      {/*} page-body-wrapper ends */}
    </div>
    {/*} container-scroller */}
    {/*} plugins:js */}
    <script src="panel/assets/vendors/js/vendor.bundle.base.js"></script>
    {/*} endinject */}
    {/*} Plugin js for this page */}
    <script src="panel/assets/vendors/jquery-bar-rating/jquery.barrating.min.js"></script>
    <script src="panel/assets/vendors/chart.js/Chart.min.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.resize.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.categories.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.fillbetween.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.stack.js"></script>
    <script src="panel/assets/js/jquery.cookie.js" type="text/javascript"></script>
    {/*} End plugin js for this page */}
    {/*} inject:js */}
    <script src="panel/assets/js/off-canvas.js"></script>
    <script src="panel/assets/js/hoverable-collapse.js"></script>
    <script src="panel/assets/js/misc.js"></script>
    <script src="panel/assets/js/settings.js"></script>
    <script src="panel/assets/js/todolist.js"></script>
    {/*} endinject */}
    {/*} Custom js for this page */}
    <script src="panel/assets/js/dashboard.js"></script>
    {/*} End custom js for this page */}
  </body>
</html>
</>
);

//}
}
export default Admin_createteam;